<template>
    <component
        :is="getCourseEnrollLayout"
        :course="renderData.course"
        :button="buttonOptions"
        :showTooltip="false"
        @purchase-option-clicked-view="handleProductClickView"
        @purchase-option-clicked-buy="handleProductClickBuy"
        @payment-plan-clicked="handlePaymentPlanClick"
        @enroll-button-clicked="handleEnrollButtonClick"
    ></component>
</template>

<script>
    import PreviewComponent from "./PreviewComponent";
    import CourseEnrollComponent from "../../components/pagesbuilder/dynamic-components/CourseEnrollComponent";
    import CourseEnrollLayout1 from "../../author/pagesbuilder/templates/cards/CourseEnrollLayout1";
    import {mapActions, mapState} from "vuex";

    export default {
        name: "PreviewCourseEnrollComponent",
        mixins: [
            PreviewComponent,
            CourseEnrollComponent
        ],
        computed: {
          ...mapState([
              'siteDefaultSignUp',
              'siteDefaultAuth',
              'paymentsURL',
          ])
        },
        methods: {
            ...mapActions('products', [
                'registerUserToCourse'
            ]),
            getCourseContentsData (selectedCourseTitleId) {
                this.getCourseContents({courseId: selectedCourseTitleId});
            },
            handleProductClickView ({productType, productId}) {
                if (!productType || !productId) {
                    return;
                }

                let url = null;
                switch (productType) {
                    case 'bundle':
                        url = `/bundles?bundle_id=${productId}`;
                        break;
                    case 'subscription':
                        url = `/subscriptions?id=${productId}`;
                        break;
                    case 'course':
                        url = `/course?courseid=${productId}`;
                        break;
                    default:
                        break;
                }
                if (url) {
                    window.location.href = url;
                }
            },
            handleProductClickBuy ({productType, productId}) {
                if (!productType || !productId) {
                    return;
                }
                if (productType === 'course') {
                    return this.isFreeCourse ? this.register() : this.buy();
                } else if (productType === 'bundle' || productType === 'subscription') {
                    window.location.href = `/payment?product_id=${productId}&type=${productType}`
                }
            },
            handlePaymentPlanClick (url) {
                window.location.href = url;
            },
            handleEnrollButtonClick () {
                if (this.buttonOptions.status === 'showcase-button') {
                    // do nothing, this is just for showcase, used when course is draft
                    // console.log('Showcase button clicked');
                } else if (this.buttonOptions.status === 'continue') {
                    this.continue();
                } else if (this.buttonOptions.status === 'enroll') {
                    if (this.myCourseData && !this.isFreeCourse) {
                        this.buy();
                    } else if (!this.isLoggedIn && this.siteDefaultAuth === 'login' && l_settings) {
                        l_settings.courseRegister = true;
                        l_settings.showEnterOnlyForm();
                    } else {
                        this.register();
                    }
                } else if (this.buttonOptions.status === 'subscribe') {
                    this.subscribe();
                }
            },
            buy () {
                if (!this.paymentsURL) {
                    showMessage("inform", this.$t('course.not_ready'), this.$t('course.not_ready_msg'), [{"name": "OK"}])
                } else {                    
                    window.location.href = this.paymentsURL + this.myCourseData.titleId;
                }
            },
            continue () {
                if (this.myCourseData && this.myCourseData.me && this.myCourseData.me.last_video_id) {
                    window.location.href = wwwelopersUrl("pathPlayer", {
                        "coursetitleid": this.myCourseData.titleId,
                        "unit": this.myCourseData.me.last_video_id
                    });
                } else if (this.myCourseData){
                    window.location.href = wwwelopersUrl("pathPlayer", {
                        "coursetitleid": this.myCourseData.titleId
                    });
                }
            },
            register () {
                if (!this.isLoggedIn && l_settings) {
                    if (this.siteDefaultSignUp === "false") {
                        l_settings.signup = 'learnworlds';
                        l_settings.courseRegister = true;
                        l_settings.showRegisterForm();
                    } else {
                        l_settings.showEnterOnlyForm();
                    }
                } else {
                    // handle user registration to course
                    const courseId = this.myCourseData.id;
                    this.registerUserToCourse({courseId})
                        .then(({data}) => {
                            if (data.success) {
                                showMessage("inform", this.$t('course.registered'), this.$t('course.welcome')+" "+ this.myCourseData.title + ". " + this.$t('course.enjoy'), [{"name":"OK"}])
                            } else {
                                displayError(data.errors);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                            displayError();
                        });
                }
            },
            subscribe () {
                //window.location.href = '/subscriptions';
            },
            componentCreationCallback(){
                if(this.pageContext?.params?.register && this.isLoggedIn && this.buttonOptions.status === 'enroll' && this.isFreeCourse){
                    //Click the button only for enroll to free
                    this.handleEnrollButtonClick();
                }
            }
        },
        components: {
            CourseEnrollLayout1
        }
    }
</script>
